import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';


@Injectable()
export class ApiServiceProvider {

  public host: string = "http://localhost:8099";
  public user;


  constructor(public http: HttpClient,
              ) {
    console.log('Hello ApiServiceProvider Provider');
  }


  // https://stackoverflow.com/questions/17397052/nodejs-passport-authentication-token?rq=1


  getObservable(url: string, getParams?){
    url = this.host + url;
    let getParams2 = null;
    if(typeof this.user!="undefined")
    {
      getParams2 = Object.assign( getParams || {}, {identificationToken: this.user.identificationToken});
    }
    else {
      getParams2 = getParams;
    }
    console.log("getParams2:",getParams2);
    return this.http.get(url, {params:getParams2});
  }

  get(url: string, getParams?): Promise<any> {
    return new Promise((resolve, reject) => {

      url = this.host + url;
      let getParams2 = null;
      if(typeof this.user!="undefined")
      {
        getParams2 = Object.assign( getParams || {}, {identificationToken: this.user.identificationToken});
      }
      else {
        getParams2 = getParams;
      }
      console.log("getParams2:",getParams2);
      this.http.get(url, {params:getParams2}).subscribe(
        (data) => {
          console.log("http get success!");
          resolve(data);
        },
        (error) => {
          console.log("http get error!");
          reject(error);
        })
    })
  }

  post(url: string, postData: Object): Promise<any> {

    // let postData2 = Object.assign(postData || {}, {identificationToken:this.user.identificationToken});
    // return fetch(this.host+url, {
    //   body:JSON.stringify(postData2),
    //   cache:'no-cache',
    //   credentials:'include',
    //   headers:{
    //     'user-agent':'majime-web',
    //     'content-type': 'application/json',
    //     'Access-Control-Allow-Origin': this.host
    //   },
    //   method:'POST',
    //   mode:'cors',
    //   redirect:'manual',
    //   referrer: 'no-referrer'
    // })

    // older way:
    return new Promise((resolve, reject) => {

      url = this.host + url;
      let postData2 = null;
      if(typeof this.user!="undefined")
      {
        postData2 = Object.assign( postData || {}, {identificationToken: this.user.identificationToken});
      }
      else {
        postData2 = postData;
      }
      console.log(postData2);
      this.http.post(url, postData2).subscribe(
        (data) => {
          console.log("http post success!");
          resolve(data);
        },
        (error) => {
          console.log(error);
          console.log("http post error!");
          reject(error);
        });
    });
  }

  put(url: string, putData: Object): Promise<any> {
    return new Promise((resolve, reject) => {
      url = this.host + url;
      let putData2 = Object.assign(putData || {}, {identificationToken:this.user.identificationToken});
      this.http.put(url, putData2).subscribe(
        (data) => {
          console.log("http put success!");
          resolve(data);
        },
        (error) => {
          console.log("http put error!");
          reject(error);
        })
    })
  }

  delete(url: string, deleteParams?): Promise<any> {
    return new Promise((resolve, reject) => {
      url = this.host + url;
      this.http.delete(url).subscribe(
        (data) => {
          console.log("http delete success!");
          resolve(data);
        },
        (error) => {
          console.log("http delete success!");
          reject(error);
        })
    })
  }


  login(username, password): Promise<any> {

    return this.post('/login', {username, password});
    // return new Promise((resolve, reject)=>{
    //   this.http.post(url, {username, password}).subscribe((response)=>{
    //     resolve(response);
    //   }, (error)=>{
    //       reject(error);
    //   });
    // });
  }

  logout(username, password): Promise<any> {
    return new Promise((resolve, reject)=>{
      this.http.post(`${this.host}/logout`, null).subscribe((response)=> {
        resolve(response);
      }, (error)=>{
        reject(error);
      });
    })
  }



  elements = {
    get: (name?: string): Promise<any> => {
      debugger;
      if(!name) {
        return this.get(`/elements/`);
      }
      else
      {
          return this.get(`/elements/${name}`);
      }
    },

    post: (data: Object): Promise<any> => {
      return this.post(`/elements`, data);
    },
    put:(data:Object):Promise<any>=>{
      return this.put(`/elements`, data);
    },
    delete:(name):Promise<any>=>{
      return this.delete(`/elements/${name}`);
    }
  }

  participants = {

    getObservable:(name?: string)=>{
      if(!name){
        return this.getObservable(`/participants`);
      }
      else {
        return this.getObservable(`/participants/${name}`);
      }
    },

    get: (name?: string): Promise<any> => {
      if(!name){
        return this.get(`/participants`);
      }
      else {
        return this.get(`/participants/${name}`);
      }
    },
    post: (data: Object): Promise<any> => {
      return this.post(`/participants`, data);
    },
    put: (data: Object): Promise<any> => {
      return this.put(`/participants`, data);
    },
    delete: (name): Promise<any> => {
      return this.delete(`/participants/${name}`);
    }
  }

};




// WEBPACK FOOTER //
// ./src/providers/api.service.ts